export default __webpack_public_path__ + "static/media/Technical Textiles.c7a2aa45.jpg";